import { TicketTypeType } from '@vista-digital/ocapi-types/v1';
export const isPackageTicketType = (ticketType) => {
    return ticketType.type === TicketTypeType.Package;
};
export const isMemberTicketType = (ticketType) => {
    return ticketType.isRestrictedToMembers;
};
export const getTicketTypeTicketCount = (ticketType) => {
    return isPackageTicketType(ticketType) ? getPackageTicketTypeTicketCount(ticketType) : 1;
};
export const getPackageTicketTypeTicketCount = (ticketType) => {
    return ticketType.tickets.reduce((acc, ticket) => acc + ticket.quantity, 0);
};
